export interface UpdateExamRequestVM {
	comment: string;
	sendEmail?: boolean;
}

export const candExamsDPRoot = 'Candidates|Program History|Exams';
